import { useEffect } from 'react';
import {
  isRunningInBiltNativeShell,
  setScanButtonHidden,
  setScanButtonOffset,
} from '../utils/nativeShell';

type Options = {
  /** Hide floating Scan while a full-screen modal/sheet is open */
  hideScan?: boolean;
  /** Extra bottom offset (px) for Scan button collision avoidance */
  scanBottomOffset?: number;
};

/**
 * Reusable web ↔ native shell chrome integration.
 * Use in modals/sheets with sticky bottom CTAs (Manage Build, Import, etc.).
 */
export function useShellChrome({ hideScan = false, scanBottomOffset = 0 }: Options = {}) {
  useEffect(() => {
    if (!isRunningInBiltNativeShell()) return;
    setScanButtonHidden(hideScan);
    if (scanBottomOffset > 0) {
      setScanButtonOffset(scanBottomOffset);
    }
    return () => {
      setScanButtonHidden(false);
      setScanButtonOffset(0);
    };
  }, [hideScan, scanBottomOffset]);
}
